import React from 'react'
import nanoid from 'nanoid'
import Range from '~/components/Range'
import Input from '~/components/Input'
import SelectedIcon from '~/icons/selected.svg'

import {
  SizeLabel,
  SizeRadio,
  StyleLabel,
  ColorLabel,
  CharacterLabel,
  CharacterRadio,
  Radio,
  Wrapper,
  SwitchWrapper,
  SwitchLabel,
  SwitchCheckbox,
  Group,
} from './styles'

const OptionItems = {
  character: ({ value, label, name, id, onChange, checked }) => (
    <>
      <CharacterRadio
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(name, value)}
      />
      <CharacterLabel htmlFor={id}>{label}</CharacterLabel>
    </>
  ),
  style: ({ value, icon, name, id, onChange, checked, labelStyle }) => (
    <>
      <Radio
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(name, value)}
      />
      <StyleLabel htmlFor={id} {...labelStyle}>
        <SelectedIcon />
        {icon}
      </StyleLabel>
    </>
  ),
  color: ({ value, colors, name, id, onChange, checked }) => (
    <>
      <Radio
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(name, value)}
      />
      <ColorLabel htmlFor={id} colors={colors}>
        <span></span>
        <span></span>
        <SelectedIcon />
      </ColorLabel>
    </>
  ),
  radio: ({
    value,
    label,
    name,
    id,
    onChange,
    checked,
    price,
    disabled = false,
  }) => (
    <>
      <SizeRadio
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(name, value)}
      />
      <SizeLabel
        tag={'label'}
        fontWeight={400}
        htmlFor={id}
        disabled={disabled}
      >
        {label} {price && <span>{price}</span>}
      </SizeLabel>
    </>
  ),
}

export const Scale = ({ name, onChange, value }) => (
  <Range
    maxValue={250}
    minValue={25}
    step={10}
    value={value}
    onChange={val => onChange(name, val)}
  />
)

export const PersonalisedText = ({
  name,
  onChange,
  id,
  value,
  label,
  placeholder,
  help = false,
}) => (
  <Input
    id={id}
    placeholder={placeholder}
    maxLength={50}
    type="textarea"
    name={name}
    label={label}
    value={value}
    onChange={val => onChange(name, val)}
    help={help}
  />
)

export const Invert = ({ name, onChange, id, value, label }) => {
  const checked = value === 'true'

  return (
    <SwitchWrapper>
      <SwitchCheckbox
        id={id}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={e => onChange(name, e.target.checked.toString())}
      />
      <SwitchLabel tag={'label'} htmlFor={id}>
        {label}
      </SwitchLabel>
    </SwitchWrapper>
  )
}

export default ({
  options = [{}],
  name,
  onChange,
  selected,
  isDesktop = true,
}) => {
  const scrollables = ['style', 'layout', 'color']
  const isScrollable = !isDesktop && scrollables.includes(name)

  const mid = Math.ceil(options.length / 2)

  const opts =
    name === 'color' && isScrollable
      ? [options.slice(0, mid), options.slice(mid)]
      : [options]

  return (
    <Wrapper isScrollable={isScrollable} name={name}>
      {opts.map((group, groupIndex) => (
        <Group key={groupIndex}>
          {group.map((item, index) => {
            const props = {
              ...item,
              ...{
                name,
                id: nanoid(),
                onChange,
                checked: selected === item.value,
              },
            }

            const selector =
              name === 'layout' || name === 'size' || name === 'frame'
                ? 'radio'
                : name

            const Component = OptionItems[selector]

            return <Component key={index} {...props} />
          })}
        </Group>
      ))}
    </Wrapper>
  )
}
